
import merge  from '../fn/stream/merge.js';
import events from '../dom/modules/events.js';
import px     from '../dom/modules/parse-length.js';

export default function setupColumn(element) {
    return merge([{}], events('resize', window))
    .reduce((c0, e) => {
        const c1 =
            element.clientWidth > px('93.75rem') ? 'width-5' :
            element.clientWidth > px('75rem')    ? 'width-4' :
            element.clientWidth > px('56.25rem') ? 'width-3' :
            element.clientWidth > px('37.5rem')  ? 'width-2' :
            '' ;

        if (c1 !== c0) {
            c0 && element.classList.remove(c0);
            c1 && element.classList.add(c1);
        }

        return c1;
    }, '');
}
